/**
 * Creates a mini-cart object from mini-cart data.
 *
 * To create a MiniCartDetails object from local storage data, use the getMiniCartDetailsFromLocalStorageData()
 * function.
 *
 * Used in general and onCartUpdated.js
 */
export class MiniCartDetails {
    // This is a numeric String in Javaland
    cartTotal: string | number;
    cartItems: number;
    cartGiftCodeAmount: string | number;
    teacherScreenName: string;
    promoCode: string;
    isGiftPurchase: boolean;
    hasItems: boolean;
    includeMonthly: boolean;
    monthlyAmount: number;
    proposalDonations?: unknown[] | undefined;

    constructor(miniCartData: string | null) {
        this.cartTotal = 0;
        this.cartItems = 0;
        this.cartGiftCodeAmount = 0;
        this.teacherScreenName = '';
        this.promoCode = '';
        this.isGiftPurchase = false;
        this.hasItems = false;
        this.includeMonthly = false;
        this.monthlyAmount = 0;

        if (miniCartData != null && miniCartData !== '') {
            const obj = JSON.parse(decodeURIComponent(miniCartData));
            if (obj.teacherScreenName) {
                this.teacherScreenName = obj.teacherScreenName;
            }
            if (obj.promoCode) {
                this.promoCode = obj.promoCode;
            }
            if (obj.isGiftPurchase) {
                this.isGiftPurchase = obj.isGiftPurchase;
            }
            this.proposalDonations = obj.proposalDonations;
            if (obj.cartGiftCodeAmount) {
                // @ts-expect-error We have to use window.formatCurrency because we're in `general`. But we don't want to
                // globally add this to the type because non-`general` callers should import `formatCurrencyV2`.
                this.cartGiftCodeAmount = window.formatCurrency(obj.cartGiftCodeAmount);
                // The cartGiftCodeAmount cookie is also created from the gift code redemption page.
                // Maybe this can be changed so we rely only the MiniCartDetails property.
                window.createCookie('cartGiftCodeAmount', obj.cartGiftCodeAmount);
            }
            if (obj.cartItems) {
                this.cartItems = parseInt(obj.cartItems);
            }
            if (obj.cartTotal) {
                // @ts-expect-error See explanation of previous window.formatCurrency usage above.
                this.cartTotal = window.formatCurrency(obj.cartTotal);
            }
            if (obj.recurringDonation) {
                this.includeMonthly = true;
                this.monthlyAmount = obj.recurringDonation.donationAmount;
            }
        }

        this.hasItems = this.cartItems > 0;
    }
}
